import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "pages/Hooks/useLocalStorage";

const THEME_KEY = "theme";

export const ADMIN = "ADMIN";
export const MANAGER = "MANAGER";
export const FINANCIAL = "FINANCIAL";
export const CREDITOR = "CREDITOR";
export const DEBTOR = "DEBTOR";

const DEFAULT_THEME = CREDITOR;

const AVAILABLE_THEMES = [ADMIN, MANAGER, FINANCIAL, CREDITOR, DEBTOR];

class ThemeHelper {
  getCurrentTheme = () => {
    const inStorage = getLocalStorageItem(THEME_KEY);
    if (!inStorage) {
      return DEFAULT_THEME;
    }
    return inStorage;
  };

  setTheme = (theme) => {
    if (!AVAILABLE_THEMES.includes(theme)) {
      theme = DEFAULT_THEME;
    }
    setLocalStorageItem(THEME_KEY, theme);
  };
  setDefaultTheme = () => {
    this.setTheme(DEFAULT_THEME);
  };

  getAvailableThemes = () => {
    return AVAILABLE_THEMES;
  };
}
const themeService = new ThemeHelper();

export default themeService;
